import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-dd315cca"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  class: "vod-search"
};
const _hoisted_2 = {
  class: "main"
};
const _hoisted_3 = {
  class: "info-warp"
};
const _hoisted_4 = {
  class: "left-warp"
};
const _hoisted_5 = {
  class: "search-input"
};
const _hoisted_6 = {
  class: "keyboard-warp"
};
const _hoisted_7 = {
  class: "top-board"
};
const _hoisted_8 = ["tabindex", "onClick"];
const _hoisted_9 = {
  class: "bottom-board"
};
const _hoisted_10 = ["tabindex", "onClick"];
const _hoisted_11 = ["tabindex", "onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  class: "right-warp"
};
const _hoisted_14 = {
  class: "search-tabs"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "result-list",
  "element-loading-background": "#000"
};
const _hoisted_17 = {
  class: "page-span"
};
import { getVodPlusSearchUrlApi } from '@/api/vodPlus';
import { debounce } from '@/utils/tools';
import { Search } from '@element-plus/icons-vue';
import { inject } from 'vue';
import MoviesOrActorItem from './moviesOrActorItem.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'vodSearchInfo',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'onSearchItemClick'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const topBoardList = ref([{
      name: 'احذف',
      fn: () => {
        dataConfig.searchParams.searchValue = dataConfig.searchParams.searchValue.slice(0, dataConfig.searchParams.searchValue.length - 1);
      }
    }, {
      name: 'أبجدية',
      fn: () => {
        isNum.value = false;
      }
    }, {
      name: '123',
      fn: () => {
        isNum.value = true;
      }
    }]);
    const currentSelectSearchTab = ref('movie');
    const resultTabs = ref([{
      label: 'فيلم',
      value: 'movie'
    }, {
      label: 'دراما تلفزيونية',
      value: 'series'
    }, {
      label: 'مخرج / ممثل',
      value: 'cast'
    }]);

    const changeSearchTabs = value => {
      dataConfig.paginationConfig.page = 0;
      currentSelectSearchTab.value = value;
      returnAllPageFunc();
    };

    const charCodeData = ref(['ا', 'ﺏ', 'ﺕ', 'ﺙ', 'ﺝ', 'ﺡ', 'ﺥ', 'ﺩ', 'ﺫ', 'ﺭ', 'ﺯ', 'ﺱ', 'ﺵ', 'ﺹ', 'ﺽ', 'ﻁ', 'ﻅ', 'ﻉ', 'ﻍ', 'ف', 'ﻕ', 'ﻙ', 'ﻝ', 'ﻡ', 'ن', 'ﻩ', 'ﻭ', 'ﻱ']);
    const numberBoardList = ref([1, 2, 3, 4, 5, 6, 7, 8, 9, 'space', 0, '.']);
    const dataConfig = reactive({
      searchParams: {
        searchValue: ''
      },
      data: [],
      paginationConfig: {
        page: 0,
        limit: 8,
        total: 0
      },
      isLoading: false
    });
    const actionForm = reactive({
      dialogConfig: {
        title: 'يبحث',
        // destroyOnClose: true,
        isShowFooter: false
      },
      close: () => {
        emit('update:modelValue', false);
      }
    });
    const allSearchData = ref([]);

    const getData = async () => {
      dataConfig.isLoading = true;
      dataConfig.data = [];

      try {
        let params = {
          cid: pageParams.categoryId,
          start: 0,
          total: 20,
          search: dataConfig.searchParams.searchValue
        };
        const res = await getVodPlusSearchUrlApi(params);
        console.log(res);

        if (res.status == 200) {
          // dataConfig.data = res.data.list.map(v => {
          //     if (v.type == 'cast') {
          //         v.nameId = v.id
          //     }
          //     return v
          // })
          // dataConfig.paginationConfig.total = res.data.totalNum
          // dataConfig.isLoading = false
          allSearchData.value = res.data.list.map(v => {
            if (v.type == 'cast') {
              v.nameId = v.id;
            }

            return v;
          });
          returnAllPageFunc();
        } else {
          dataConfig.isLoading = false;
        }
      } catch (error) {
        if (error.message !== 'canceled') {
          dataConfig.isLoading = false;
        }
      } // returnAllPageFunc()

    };

    const returnAllPageFunc = async () => {
      dataConfig.isLoading = true;
      dataConfig.data = [];
      setTimeout(() => {
        try {
          let filterData = allSearchData.value.filter(item => item.type == currentSelectSearchTab.value);
          let newArr = JSON.parse(JSON.stringify(filterData));
          dataConfig.data = newArr.splice(dataConfig.paginationConfig.page * dataConfig.paginationConfig.limit, dataConfig.paginationConfig.limit);
          dataConfig.paginationConfig.total = filterData.length;
        } catch (error) {}

        dataConfig.isLoading = false;
      }, 300);
    };

    const onSearch = debounce(() => {
      dataConfig.paginationConfig.page = 0;
      getData();
    }, 200);
    const isNum = ref(false);

    const onLetterItemClick = item => {
      console.log(item);
      dataConfig.searchParams.searchValue += item;
    };

    const onNumItemClick = item => {
      dataConfig.searchParams.searchValue += item == 'space' ? ' ' : item;
    };

    const handlePaginationChange = val => {
      dataConfig.paginationConfig.page = val - 1;
      returnAllPageFunc();
    }; // 搜索列表item点击事件


    const rightListItemClick = item => {
      //   console.log(item);
      emit('onSearchItemClick', item);
    };

    const pageParams = inject('pageParams');
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_empty = _resolveComponent("el-empty");

      const _component_el_pagination = _resolveComponent("el-pagination");

      const _component_m_dialog = _resolveComponent("m-dialog");

      const _directive_loading = _resolveDirective("loading");

      return __props.modelValue ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_m_dialog, {
        nativeConfig: {
          width: '70%',
          closeOnClickModal: false
        },
        modelValue: __props.modelValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _isRef(modelValue) ? modelValue.value = $event : null),
        "dialog-config": actionForm.dialogConfig,
        onOnClose: actionForm.close
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_input, {
          modelValue: dataConfig.searchParams.searchValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dataConfig.searchParams.searchValue = $event),
          placeholder: "من فضلك أدخل المفتاح",
          onKeyup: _withKeys(_unref(onSearch), ["enter", "native"])
        }, {
          prepend: _withCtx(() => [_createVNode(_component_el_button, {
            icon: _unref(Search),
            onClick: _unref(onSearch)
          }, null, 8, ["icon", "onClick"])]),
          _: 1
        }, 8, ["modelValue", "onKeyup"])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topBoardList.value, (item, index) => {
          return _openBlock(), _createElementBlock("span", {
            class: "key-item top-board-item",
            key: index,
            tabindex: index,
            onClick: item.fn
          }, _toDisplayString(item.name), 9, _hoisted_8);
        }), 128))]), _createElementVNode("div", _hoisted_9, [!isNum.value ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(charCodeData.value, (item, index) => {
          return _openBlock(), _createElementBlock("span", {
            class: "key-item",
            key: index,
            tabindex: index,
            onClick: $event => onLetterItemClick(item)
          }, _toDisplayString(item), 9, _hoisted_10);
        }), 128)) : _createCommentVNode("", true), isNum.value ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 1
        }, _renderList(numberBoardList.value, (item, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: index
          }, [item != 'space' ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "key-item num-key",
            tabindex: index,
            onClick: $event => onNumItemClick(item)
          }, _toDisplayString(item), 9, _hoisted_11)) : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "key-item num-key iconfont icon-kongge",
            onClick: $event => onNumItemClick(item)
          }, null, 8, _hoisted_12))], 64);
        }), 128)) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultTabs.value, (item, index) => {
          return _openBlock(), _createElementBlock("span", {
            class: _normalizeClass(["tabs-item pointer", item.value == currentSelectSearchTab.value ? 'is-search-tab-select' : '']),
            key: index,
            onClick: $event => changeSearchTabs(item.value)
          }, _toDisplayString(item.label), 11, _hoisted_15);
        }), 128))]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [dataConfig.data.length ? (_openBlock(true), _createElementBlock(_Fragment, {
          key: 0
        }, _renderList(dataConfig.data, (item, index) => {
          return _openBlock(), _createBlock(MoviesOrActorItem, {
            poster: item.image,
            "program-name": item.name,
            onClick: $event => rightListItemClick(item)
          }, null, 8, ["poster", "program-name", "onClick"]);
        }), 256)) : _createCommentVNode("", true), dataConfig.data.length == 0 && !dataConfig.isLoading ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "لا توجد بيانات",
          style: {
            "width": "100%"
          },
          "image-size": 50
        })) : _createCommentVNode("", true)])), [[_directive_loading, dataConfig.isLoading]])])]), _createElementVNode("div", {
          class: "pagination",
          style: _normalizeStyle(dataConfig.paginationConfig.total > dataConfig.paginationConfig.limit && !dataConfig.isLoading ? '' : 'visibility: hidden')
        }, [_createVNode(_component_el_pagination, {
          small: "",
          background: "",
          layout: "prev, pager, next, slot",
          "current-page": dataConfig.paginationConfig.page + 1,
          "page-size": dataConfig.paginationConfig.limit,
          total: dataConfig.paginationConfig.total,
          onCurrentChange: handlePaginationChange
        }, {
          default: _withCtx(() => [_createElementVNode("span", _hoisted_17, _toDisplayString(dataConfig.paginationConfig.page * dataConfig.paginationConfig.limit + 1 + '-' + (dataConfig.paginationConfig.total / (dataConfig.paginationConfig.page + 1) > dataConfig.paginationConfig.limit ? (dataConfig.paginationConfig.page + 1) * dataConfig.paginationConfig.limit : dataConfig.paginationConfig.total)) + " of " + _toDisplayString(dataConfig.paginationConfig.total) + " items ", 1)]),
          _: 1
        }, 8, ["current-page", "page-size", "total"])], 4)])]),
        _: 1
      }, 8, ["modelValue", "dialog-config", "onOnClose"])])) : _createCommentVNode("", true);
    };
  }

});